<template>
	<div class="trialfeedback">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="communitylist">
        <div class="listItem" ref="listItem1">
          <community-item v-for="(item, index) in list1" :prolistItem="item" :key="index"></community-item>
        </div>
        <div class="listItem" ref="listItem2">
          <community-item v-for="(item, index) in list2" :prolistItem="item" :key="index"></community-item>
        </div>
      </div>
    </Scroller>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import communityItem from '../common/communityItem'
export default {
  name: 'trialfeedback',
  components: {
    Scroller,
    communityItem
  },
  data () {
    return {
      list1: [],
      list2: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      next(vm => {
        Object.assign(vm.$data, vm.$options.data())
      })
    } else {
      next(vm => {
        if (from.path != '/communitydetail') Object.assign(vm.$data, vm.$options.data())
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/communitydetail') this.loading = true
    next()
  },
  methods: {
    getData () {
      var url = this.$ajax.getFeedbackList_URL
      url= url + '?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize + '&actid=' + this.$route.query.actid
      this.$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            if (this.nowPage == 1) {
              this.list1 = []
              this.list2 = []
              this.refresh = false
            }
            if (res.data.list.length < this.pagesize) {
              this.finished = true
              if (this.nowPage == 1 && !res.data.list.length) {
                this.list1 = []
                this.list2 = []
              }
            } else {
              this.finished = false
            }
            this.$nextTick(() => {
              setTimeout(() => {
                this.doSort(0, res.data.list)
              })
            })
          }
        })
    },
    doSort (index, list) {
      let that = this
      if (index < list.length) {
        f()
        function f() {
          if (that.$refs.listItem1.clientHeight <= that.$refs.listItem2.clientHeight) {
            that.list1.push(list[index])
          } else {
            that.list2.push(list[index])
          }
          if (index < list.length - 1) {
            that.loading = true
          } else {
            that.loading = false
          }
          that.$nextTick(() => {
            setTimeout(() => {
              that.doSort(index + 1, list)
            }, 100)
          })
        }
      }
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
  }
}
</script>

<style scoped lang="scss">
  .trialfeedback {
    .communitylist {
      width: 100%;
      padding-right: 0.1rem;
      margin-top: 0.1rem;
      overflow: hidden;
      .listItem {
        padding-left: 0.1rem; // 剧中
        width: 50%;
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/trialfeedback.vue